var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBriefcaseMainTabFiledIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 8.04175H7.33333C6.59695 8.04175 6 8.6387 6 9.37508V16.0417C6 16.7781 6.59695 17.3751 7.33333 17.3751H18C18.7364 17.3751 19.3333 16.7781 19.3333 16.0417V9.37508C19.3333 8.6387 18.7364 8.04175 18 8.04175Z",
    fill: "url(#paint0_linear_78_9141)",
    stroke: "url(#paint1_linear_78_9141)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 17.375V6.70833C15.3333 6.35471 15.1929 6.01557 14.9428 5.76552C14.6928 5.51548 14.3536 5.375 14 5.375H11.3333C10.9797 5.375 10.6406 5.51548 10.3905 5.76552C10.1405 6.01557 10 6.35471 10 6.70833V17.375",
    stroke: "url(#paint2_linear_78_9141)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_78_9141",
    x1: 5.13333,
    y1: 12.7084,
    x2: 16.058,
    y2: 20.8605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8747F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D60F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_78_9141",
    x1: 5.13333,
    y1: 12.7084,
    x2: 16.058,
    y2: 20.8605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8747F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D60F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_78_9141",
    x1: 9.65333,
    y1: 11.375,
    x2: 16.1086,
    y2: 12.8736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8747F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D60F4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcaseMainTabFiledIcon);
export default __webpack_public_path__ + "static/media/briefcase-main-tab-filed-icon.a845a3b01ab7832cfa3c1e765ec254de.svg";
export { ForwardRef as ReactComponent };